import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 6E8EC35B-2DF2-4451-9649-E0DBA823E3B7
 * name eject-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/eject-outline.svg
 * tags
 */
export const EjectOutlineIcon = createSvgIcon(<><path d="M5,17H19V19H5V17M12,5L5.33,15H18.67L12,5M12,8.6L14.93,13H9.07L12,8.6Z" /></>, 'EjectOutlineIcon');
export default EjectOutlineIcon